import { createApi } from '@reduxjs/toolkit/query/react';
import deserialize from 'helpers/getroPropertyMapper';
import { networkBaseQueryV2 } from './queries';
import removeEmptyProps from '../helpers/removeEmptyProps';

const DEFAULT_FILTER = {
  sortBy: 'createdAt',
  sortDirection: 'desc',
  visibility: null,
  source: null,
  status: null,
  expiration: null,
  featured: null,
  expirationWithin: null,
  locationIds: [],
};

export const jobsV2Api = createApi({
  reducerPath: 'jobsV2Api',
  baseQuery: networkBaseQueryV2,
  tagTypes: ['jobs'],
  endpoints: (builder) => ({
    getJobs: builder.query({
      query: ({ page = 1, hitsPerPage = 20, filters, networkId }) => ({
        url: '/jobs',
        params: {
          page,
          perPage: hitsPerPage,
          ...removeEmptyProps({ ...DEFAULT_FILTER, ...filters }),
        },
        networkId,
      }),
      providesTags: ['jobs'],
      transformResponse: (response) => deserialize(response),
    }),
    getJob: builder.query({
      query: ({ jobId, networkId }) => ({
        url: `/jobs/${jobId}`,
        networkId,
      }),
      transformResponse: (response) => deserialize(response),
      providesTags: ['jobs'],
    }),
    getPublicJobBySlug: builder.query({
      query: ({ jobSlug, collectionId }) => ({
        url: `/jobs/${jobSlug}`,
        params: {
          collection_id: collectionId,
        },
        options: {
          network: null, // Don't auto-add collection path
          version: 'v1',
        },
      }),
    }),
    exportJobs: builder.mutation({
      query: ({ filters, selectedJobs, filterByCollection }) => ({
        url: '/jobs/export',
        params: {
          ...removeEmptyProps({ ...DEFAULT_FILTER, ...filters }),
          ...(selectedJobs ? { ids: selectedJobs } : {}),
          ...(typeof filterByCollection === 'boolean' ? { filterByCollection } : {}),
        },
        method: 'post',
      }),
    }),
  }),
});

export const {
  useGetJobsQuery,
  useLazyGetJobsQuery,
  useGetJobQuery,
  useExportJobsMutation,
  useLazyGetJobQuery,
  useGetPublicJobBySlugQuery,
  useLazyGetPublicJobBySlugQuery,
} = jobsV2Api;
